import * as React from "react";
export const FontSizeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 27 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.66663 4.33329V1.66663H19V4.33329M11 1.66663V20.3333M13.6666 20.3333H8.33329M17.6666 12.3333V11H25.6666V12.3333M21.6666 11V20.3333M20.3333 20.3333H23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
